export default __webpack_public_path__ + "static/media/logoutIcon.73fc348e.svg";